export default __webpack_public_path__ + "static/media/ZakiBrahmi.247ffab9.JPG";